import { 
    LEGAL_PERSON_GET_REQUEST, LEGAL_PERSON_GET_SUCCESS, LEGAL_PERSON_GET_ERROR, 
    LEGAL_PERSON_GET_BY_KEY_REQUEST, LEGAL_PERSON_GET_BY_KEY_SUCCESS, LEGAL_PERSON_GET_BY_KEY_ERROR, 
    LEGAL_PERSON_ADD_REQUEST, LEGAL_PERSON_ADD_SUCCESS, LEGAL_PERSON_ADD_ERROR, 
    LEGAL_PERSON_EDIT_REQUEST, LEGAL_PERSON_EDIT_SUCCESS, LEGAL_PERSON_EDIT_ERROR, 
    LEGAL_PERSON_DELETE_REQUEST, LEGAL_PERSON_DELETE_SUCCESS, LEGAL_PERSON_DELETE_ERROR
} from "../constants/legalPersonConstants";

const initialState = {
    legalPersons: [],
    legalPerson: {},
    loading: false,
    success: null,
    error: null,
    legalPersonRequestedCount: 0,
};

export const legalPersonReducer = (state = initialState, action) => {
    switch (action.type)     {
        case LEGAL_PERSON_GET_REQUEST:
            return {
                ...state,
                legalPersonRequestedCount: ++state.legalPersonRequestedCount,
                loading: true,
            };
        case LEGAL_PERSON_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                legalPersons: action.payload,
                success: true,
            };
        case LEGAL_PERSON_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case LEGAL_PERSON_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case LEGAL_PERSON_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                legalPerson: action.payload,
                success: true,
            };
        case LEGAL_PERSON_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case LEGAL_PERSON_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case LEGAL_PERSON_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case LEGAL_PERSON_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case LEGAL_PERSON_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case LEGAL_PERSON_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case LEGAL_PERSON_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case LEGAL_PERSON_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case LEGAL_PERSON_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case LEGAL_PERSON_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
